import '../stylesheets/contact.css';

import React, { useEffect, useRef, useState } from 'react';
import { Button } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';

import { getDocuments } from '../actions/documents';
import globalStyles from '../stylesheets/globalStyles';
import type { Document } from '../types/Document';
import AddDocumentModal from './AddDocumentModal';
import AddNewButton from './AddNewButton';
import ShowDocumentModal from './ShowDocumentModal';

const i18nPrefix = 'MaintainDocuments';

type Props = {
  id_params: {
    mooring_id?: number | null;
    contact_id?: number | null;
    badge_id?: number | null;
    assigned_contact_id?: number | null;
    waiting_contact_id?: number | null;
  };
};

export default function DocumentMaintainArea(props: Props) {
  const { t } = useTranslation();
  const [documents, setDocuments] = useState([]);
  const actionButtonStyle = {
    ...globalStyles.normalButton,
    width: 'auto',
    height: 'auto',
    margin: 0,
    padding: '4px 10px',
  };

  const addDocumentModal = useRef<{
    show: () => void;
  } | null>(null);

  const showDocumentModal = React.useRef<{
    show: (document: Document) => void;
  } | null>(null);

  useEffect(() => {
    reloadDocuments();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onShowButtonClicked = (document: Document) => {
    if (showDocumentModal.current) {
      showDocumentModal.current.show(document);
    }
  };

  const reloadDocuments = () => {
    getDocuments(
      props.id_params,
      (documents) => {
        const sorted = [...documents].sort((a, b) =>
          (a.title || '').localeCompare(b.title || '', undefined, {
            sensitivity: 'base',
          }),
        );
        setDocuments(sorted);
      },
      (error) => {
        console.log('error', error);
      },
      () => {},
    );
  };

  return (
    <div style={{ marginBottom: 5 }}>
      <h3 className='contact-modal__section-title'>
        {t(`${i18nPrefix}.documents`)}
      </h3>
      <AddDocumentModal
        onRef={addDocumentModal}
        onClose={reloadDocuments}
        id_params={props.id_params}
      />
      <ShowDocumentModal onRef={showDocumentModal} onClose={reloadDocuments} />

      {documents.length > 0 && (
        <div className='contact-entities__table'>
          <div className='contact-entities__row contact-entities__row--header contact-documents__row'>
            <div>{t(`${i18nPrefix}.title`, 'Title')}</div>
            <div className='contact-entities__actions-title'>
              {t('global.action', 'Action')}
            </div>
          </div>
          {documents.map((document) => {
            return (
              <div
                key={document.id}
                className='contact-entities__row contact-documents__row'>
                <div>{`${document.title}`}</div>
                <div className='contact-entities__actions'>
                  <Button
                    className='contact-modal__action-btn'
                    style={actionButtonStyle}
                    onClick={() => onShowButtonClicked(document)}>
                    {t(`${i18nPrefix}.show`)}
                  </Button>
                </div>
              </div>
            );
          })}
        </div>
      )}
      {documents.length === 0 && (
        <div className='contact-entities__empty'>
          {t(`${i18nPrefix}.noDocuments`, 'No documents yet')}
        </div>
      )}

      <AddNewButton
        center
        label={t(`${i18nPrefix}.addDocument`)}
        onClick={() => {
          addDocumentModal.current.show();
        }}
      />
    </div>
  );
}
